export const DEBUG_MODE_PARAM = '_d';
export const SESSION_ID_PARAM = 'session_id';
